export const faq = ()=> {

    const faqItems = document.querySelectorAll(".faq__item");

    faqItems.forEach((currentTab) =>{
        let headPart = currentTab.querySelector(".faq__head");
        let hiddenPart = currentTab.querySelector(".faq__hide");

        headPart.addEventListener('click' , (e) =>{
            let hiddenPartHeight = hiddenPart.scrollHeight;

            if (currentTab.classList.contains('active')) {
                // Закрити вже відкриту вкладку
                currentTab.classList.remove('active');
                hiddenPart.style.maxHeight = null;
            } else {
                // Закрити всі інші вкладки
                faqItems.forEach(item => {
                    item.classList.remove('active');
                    item.querySelector('.faq__hide').style.maxHeight = null;
                });
                // Відкрити клікнуту вкладку
                currentTab.classList.add('active');
                hiddenPart.style.maxHeight = hiddenPartHeight + 'px';
            }
        })
    })

}